<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="text-h5 pa-4"> Create Medication </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <v-form ref="form" v-model="valid">
            <div class="mb-4">
              <v-text-field
                v-model="formData.medication_name"
                :rules="[(v) => !!v || 'Medication Name is required']"
                label="Medication Name"
                variant="outlined"
                density="compact"
                class="mb-2"
                required
              ></v-text-field>

              <v-autocomplete
                v-model="formData.medication_class_id"
                :items="medicationClassOptions"
                item-title="text"
                item-value="value"
                label="Medication Class"
                variant="outlined"
                density="compact"
                class="mb-2"
                @update:model-value="handleMedicationClassChange"
              ></v-autocomplete>

              <v-text-field
                v-model="formData.brand_name"
                label="Brand Name"
                variant="outlined"
                density="compact"
                class="mb-2"
              ></v-text-field>
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="handleClose">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            variant="flat"
            :disabled="!valid || loading"
            :loading="loading"
            @click="handleSubmit"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { create_master_medications } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";
import GetMedicationClasses from "@/mixins/Medication/GetMedicationClasses";

export default {
  name: "CreateMedicationDialog",
  mixins: [GetMedicationClasses],
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "created"],
  data() {
    return {
      valid: false,
      loading: false,
      formData: {
        medication_name: "",
        medication_class: "",
        medication_class_id: "",
        brand_name: "",
      },
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue(newVal) {
      if (newVal) {
        this.fetchMedicationClasses();
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    handleMedicationClassChange(value) {
      const selectedClass = this.medicationClassesList.find(
        (medClass) => medClass.class_id === value
      );
      if (selectedClass) {
        this.formData.medication_class = selectedClass.class_name;
      }
    },
    handleClose() {
      this.dialog = false;
      this.resetForm();
    },
    resetForm() {
      this.formData = {
        medication_name: "",
        medication_class: "",
        medication_class_id: "",
        brand_name: "",
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async handleSubmit() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        return;
      }

      this.loading = true;

      try {
        const input = {
          medication_name: this.formData.medication_name,
          medication_class: this.formData.medication_class || "",
          medication_class_id: this.formData.medication_class_id || "",
          brand_name: this.formData.brand_name || "",
        };

        const response = await client.graphql({
          query: create_master_medications,
          variables: {
            input: input,
          },
        });

        // console.log(response);
        const responseData = JSON.parse(response.data.create_master_medications);

        if (responseData.status == "SUCCESS") {
          this.loading = false;
          this.snackbar = {
            show: true,
            message: responseData.status_message || "Medication created successfully",
            color: "success",
          };
          this.$emit("created", 0);
          this.handleClose();
        } else {
          this.loading = false;
          this.snackbar = {
            show: true,
            message: responseData.status_message || "Failed to create medication",
            color: "error",
          };
        }
      } catch (error) {
        this.loading = false;
        console.error("Error creating medication:", error);
        this.snackbar = {
          show: true,
          message:
            error.message || "An error occurred while creating the medication",
          color: "error",
        };
      }
    },
  },
};
</script>

<style scoped>
</style>

